import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { useStrip } from '../../plot/hooks/useStrip';
import { getExtent } from '../../plot/utils/scale';
import { timestampSelector } from '../selectors/navigation.selectors';
import { clamp } from 'lodash';

export const useWindow = () => {
  const ecgDuration = useSelector(roundedDurationSelector);
  const { xScale } = useStrip();
  const duration = getExtent(xScale.domain());
  const timestamp = useSelector(timestampSelector);
  const prevTimestamp = useRef(timestamp);
  const prevOffset = useRef(0);

  const start = prevOffset.current;
  const end = start + duration;
  const offset = duration / 10;
  const tenthPercentile = start + offset;
  const ninetiethPercentile = end - offset;

  let direction: 0 | -1 | 1 = 0;
  if (prevTimestamp.current < timestamp) {
    direction = +1;
  } else if (prevTimestamp.current > timestamp) {
    direction = -1;
  }

  if (timestamp > ninetiethPercentile && direction === +1) {
    prevOffset.current += timestamp - ninetiethPercentile;
  }

  if (timestamp < tenthPercentile && direction === -1) {
    prevOffset.current += timestamp - tenthPercentile;
  }

  prevTimestamp.current = timestamp;
  return clamp(prevOffset.current, 0, ecgDuration - duration);
};
